import { z } from 'zod';

export type MultipartUploadPart = z.infer<typeof multipartUploadPartSchema>;

export const multipartUploadPartSchema = z.object({
  partNumber: z.number(),
  url: z.string(),
});

export type MultipartUploadFile = z.infer<typeof multipartUploadFileSchema>;

export const multipartUploadFileSchema = z.object({
  bucket: z.string(),
  key: z.string(),
  uploadId: z.string(),
  parts: z.array(multipartUploadPartSchema),
});

export type MultipartUpload = z.infer<typeof multipartUploadSchema>;

/** Multipart upload session (browser → S3 via presigned URLs). */
export const multipartUploadSchema = z.object({
  /** Matches server S3 multipart part size; use when slicing each `File` for PUTs. */
  partSizeBytes: z.number(),
  sessionId: z.string(),
  files: z.array(multipartUploadFileSchema),
});

export type CompleteMultipartUploadPart = z.infer<typeof completeMultipartUploadPartSchema>;

export const completeMultipartUploadPartSchema = z.object({
  partNumber: z.number().int().min(1),
  etag: z.string(),
});

export type CompleteMultipartUploadFile = z.infer<typeof completeMultipartUploadFileSchema>;

export const completeMultipartUploadFileSchema = z.object({
  bucket: z.string(),
  key: z.string(),
  uploadId: z.string(),
  parts: z.array(completeMultipartUploadPartSchema),
});

export type CompleteMultipartUploadPayload = z.infer<typeof completeMultipartUploadPayloadSchema>;

/**
 * Body of POST …/uploads/:uploadId/complete. The `uploadId` comes from the URL param, so the
 * file entries carry only bucket, key and parts.
 */
export const completeMultipartUploadPayloadSchema = completeMultipartUploadFileSchema.omit({
  uploadId: true,
});

export type CompleteMultipartUpload = z.infer<typeof completeMultipartUploadSchema>;

export const completeMultipartUploadSchema = z.object({
  files: z.array(completeMultipartUploadFileSchema),
});
